import { Component, OnInit } from '@angular/core';
import { ChiSiamoService } from '../chi-siamo/chi-siamo.service';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-ict-radio',
  templateUrl: './ict-radio.component.html',
  styleUrls: ['./ict-radio.component.scss'],
    providers: [ChiSiamoService, HttpClient]
})
export class IctRadioComponent implements OnInit {

  
  descrizioneSistemiInformativi: any;
  descrizioneTrasmissioneDati: any;
  descrizioneRadio: any;

  constructor(
    public restService: ChiSiamoService,private _sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.findDescrizioni();
  }

  findDescrizioni() {
    this.restService.findAllDescrizione().then(res => {
      if (res && Array.isArray(res)) {
        // Cerca per idExtraAsset invece di usare indici array
        const sistemiInfo = res.find((item: any) => item.idExtraAsset === 2);
        const trasmissioneDati = res.find((item: any) => item.idExtraAsset === 3);
        const radio = res.find((item: any) => item.idExtraAsset === 4);

        this.descrizioneSistemiInformativi = this._sanitizer.bypassSecurityTrustHtml(
          sistemiInfo?.descrizione?.trim()
            ? sistemiInfo.descrizione
            : '<p><em>Nessun contenuto trovato per questa sezione</em></p>'
        );
  
        this.descrizioneTrasmissioneDati = this._sanitizer.bypassSecurityTrustHtml(
          trasmissioneDati?.descrizione?.trim()
            ? trasmissioneDati.descrizione
            : '<p><em>Nessun contenuto trovato per questa sezione</em></p>'
        );
  
        this.descrizioneRadio = this._sanitizer.bypassSecurityTrustHtml(
          radio?.descrizione?.trim()
            ? radio.descrizione
            : '<p><em>Nessun contenuto trovato per questa sezione</em></p>'
        );
      } else {
        // fallback globale se res è null o vuoto
        this.descrizioneSistemiInformativi =
        this.descrizioneTrasmissioneDati =
        this.descrizioneRadio = this._sanitizer.bypassSecurityTrustHtml(
          '<p><em>Nessun contenuto trovato per questa sezione</em></p>'
        );
      }
    });
  }
  
}
